import { render, staticRenderFns } from "./modalWrapper.vue?vue&type=template&id=65c27760"
import script from "./modalWrapper.vue?vue&type=script&lang=js"
export * from "./modalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports